import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const QuestionsAnswers = () => {
  const [open, setOpen] = useState(null);

  const faqs = [
    {
      question: "নিঃস্বার্থ নবজীবন সংগঠন (NNS) কি আনুষ্ঠানিকভাবে নিবন্ধিত?",
      answer:
        "না, এটি যুব উন্নয়ন অধিদপ্তর ও সমাজ সেবা অফিসের নিবন্ধনের আবেদন প্রক্রিয়া চলমান রয়েছে।",
      category: "organization",
    },
    {
      question: "নিঃস্বার্থ নবজীবন সংগঠন (NNS) কোন ধরনের কাজ করে?",
      answer:
        "নিঃস্বার্থ নবজীবন সংগঠন (NNS) অসহায়, নিঃস্ব, নিপীড়িত মানুষ ও অনাথ পথশিশু তাদের অন্ন, বস্ত্র, শিক্ষা, চিকিৎসা ও বাসস্থান এই মৌলিক অধিকার নিশ্চিতসহ স্বাবলম্বীকরণ প্রজেক্টের মাধ্যমে একজন দক্ষ জনগোষ্ঠী তৈরিতে কাজ করে। এছাড়াও দূর্যোগকালীন পরিস্থিতিতে যেমন- করোনা মহামারিতে ও বন্যার সময় ত্রাণ বিতরণ কর্মসূচিসহ যেকোনো ক্রান্তিলগ্নে মানুষের সেবায় সর্বদা নিয়োজিত থাকে।",
      category: "activities",
    },
    {
      question: "আমি কিভাবে যুক্ত হতে পারি?",
      answer:
        "আপনি আমাদের সাথে একজন দাতা/স্বেচ্ছাসেবক হয়ে যুক্ত হতে পারেন, বিস্তারিত জানতে ভিজিট করুন http://pbtsbd.org/join",
      category: "involvement",
    },
    {
      question: "নিঃস্বার্থ নবজীবন সংগঠন (NNS ) প্রতিষ্ঠিত হয় কখন?",
      answer:
        "২০১৩ সালে, চট্টগ্রাম জেলার চন্দনাইশ থানায়- কিছু স্বপ্নবাজ তরুণের উদ্দ্যোগে প্রতিষ্ঠিত।",
      category: "organization",
    },
    {
      question: "নিঃস্বার্থ নবজীবন সংগঠন (NNS) কি ধরণের প্রতিষ্ঠান?",
      answer:
        "নিঃস্বার্থ নবজীবন সংগঠন (NNS) একটি অরাজনৈতিক, অলাভজনক, সামাজিক ও সেবামূলক সংগঠন।",
      category: "organization",
    },
    {
      question:
        "কিভাবে আমার প্রতিষ্ঠান নিঃস্বার্থ নবজীবন সংগঠন (NNS) কে সহায়তা করতে পারে?",
      answer:
        "এই প্রতিষ্ঠান কে সমৃদ্ধি করার জন্য শুধু মাত্র আর্থিক সহায়তাই যথেষ্ট নয়। আপনার যোগাযোগ মাধ্যমের দক্ষতা দিয়ে আরো কিছু মহৎ প্রাণ মানুষদের আমাদের সাথে যুক্ত করতে পারেন। নিম্নবর্ণিত উপায়ে আপনি আমাদের সাথে যুক্ত হতে পারেনঃ ক) আপনাদের কর্মীদের আমাদের স্বেচ্ছাসেবক কাজে যুক্ত করে।",
      category: "involvement",
    },
    {
      question: "আপনারা কি রাস্তায় দাঁড়িয়ে তহবিল সংগ্রহ করেন?",
      answer:
        "জ্বি না, আমরা আমাদের ব্যাংক অ্যাকাউন্ট, বিকাশ, রকেট, পেপল এবং শাখা অফিসের মাধ্যমে তহবিল সংগ্রহ করে থাকি।",
      category: "donation",
    },
  ];

  // Get unique categories
  const categories = Array.from(new Set(faqs.map((faq) => faq.category)));

  // Toggle handler for collapsible items
  const handleToggle = (index) => {
    setOpen(open === index ? null : index);
  };

  // Get category name in Bengali
  const getCategoryName = (category) => {
    switch (category) {
      case "organization":
        return "সংগঠন সম্পর্কে";
      case "activities":
        return "কার্যক্রম";
      case "involvement":
        return "অংশগ্রহণ";
      case "donation":
        return "অনুদান";
      default:
        return category;
    }
  };

  return (
    <div className="py-8 px-4 md:px-8 bg-gradient-to-b from-white to-primary/5">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            সাধারণ জিজ্ঞাসা
          </h2>
          <p className="text-lg text-gray-600">
            আপনার প্রশ্নের উত্তর এখানে খুঁজে না পেলে, আমাদের সাথে যোগাযোগ করুন
          </p>
        </div>

        {categories.map((category) => (
          <div key={category} className="mb-8">
            <h3 className="text-xl font-semibold mb-4 text-primary border-b pb-2">
              {getCategoryName(category)}
            </h3>
            <div className="space-y-4">
              {faqs
                .filter((faq) => faq.category === category)
                .map((faq, index) => {
                  const faqIndex = faqs.indexOf(faq);
                  return (
                    <div
                      key={faqIndex}
                      tabIndex={0}
                      className={`collapse collapse-arrow bg-base-100 border-base-300 border ${
                        open === faqIndex ? "collapse-open" : ""
                      }`}
                      onClick={() => handleToggle(faqIndex)}
                    >
                      <div className="collapse-title font-semibold">
                        {faq.question}
                      </div>
                      <div className="collapse-content text-sm">
                        <p>{faq.answer}</p>
                        {faq.category === "involvement" && (
                          <div className="mt-4">
                            <a
                              href="http://pbtsbd.org/join"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="inline-block px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                            >
                              আমাদের সাথে যুক্ত হন
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        ))}

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">আরও প্রশ্ন আছে?</p>
          <a
            href="mailto:support@pbtsbd.org"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-white shadow transition-colors hover:bg-blue-700 focus:outline-none"
          >
            আমাদের সাথে যোগাযোগ করুন
          </a>
        </div>
      </div>
    </div>
  );
};

export default QuestionsAnswers;
